var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 205,
    viewBox: "0 0 236 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.02 175.67C162.23 175.67 199.692 138.142 199.692 91.6868C199.692 45.2311 162.065 7.70287 116.02 7.70287C69.81 7.70287 32.347 45.2311 32.347 91.6868C32.347 138.142 69.81 175.67 116.02 175.67Z",
    fill: "url(#paint0_linear_19_110)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M204.148 10.1828C206.7 10.1828 208.769 8.11026 208.769 5.55373C208.769 2.99718 206.7 0.924692 204.148 0.924692C201.597 0.924692 199.527 2.99718 199.527 5.55373C199.527 8.11026 201.597 10.1828 204.148 10.1828Z",
    fill: "#253040"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8027 36.4692C39.3548 36.4692 41.4237 34.3965 41.4237 31.8401C41.4237 29.2836 39.3548 27.2111 36.8027 27.2111C34.2506 27.2111 32.1818 29.2836 32.1818 31.8401C32.1818 34.3965 34.2506 36.4692 36.8027 36.4692Z",
    fill: "#253040"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58182 125.743C13.3214 125.743 17.1636 121.894 17.1636 117.146C17.1636 112.399 13.3214 108.55 8.58182 108.55C3.84221 108.55 0 112.399 0 117.146C0 121.894 3.84221 125.743 8.58182 125.743Z",
    fill: "#253040"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_19_110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.958 48.2161V145.488C195.958 148.342 193.584 150.72 190.734 150.72H43.1812C40.3322 150.839 37.958 148.461 37.958 145.607V48.2161C37.958 45.2433 40.3322 42.9838 43.1812 42.9838H190.734C193.702 42.9838 195.958 45.3622 195.958 48.2161Z",
    fill: "url(#paint1_linear_19_110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2994 124.252C92.6063 124.252 92.0516 123.974 91.4971 123.557C90.5265 122.585 90.5265 120.918 91.4971 119.946C97.8749 113.696 106.333 110.224 115.345 110.224C124.357 110.224 132.815 113.696 139.193 119.946C140.163 120.918 140.163 122.585 139.193 123.557C138.222 124.529 136.558 124.529 135.588 123.557C130.18 118.14 122.971 115.224 115.345 115.224C107.719 115.224 100.509 118.14 95.102 123.557C94.5473 123.974 93.9928 124.252 93.2994 124.252Z",
    fill: "#B8C5CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.034 87.0285L105.362 83.6951C106.333 82.7229 106.333 81.0562 105.362 80.084C104.391 79.1117 102.728 79.1117 101.757 80.084L98.4296 83.4174L95.102 80.084C94.1314 79.1117 92.4675 79.1117 91.4971 80.084C90.5265 81.0562 90.5265 82.7229 91.4971 83.6951L94.8247 87.0285L91.4971 90.3619C90.5265 91.3342 90.5265 93.0008 91.4971 93.9731C92.0516 94.5287 92.6063 94.6676 93.2994 94.6676C93.9928 94.6676 94.5473 94.3899 95.102 93.9731L98.4296 90.6397L101.757 93.9731C102.312 94.5287 102.866 94.6676 103.56 94.6676C104.253 94.6676 104.807 94.3899 105.362 93.9731C106.333 93.0008 106.333 91.3342 105.362 90.3619L102.034 87.0285Z",
    fill: "#B8C5CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.727 87.0285L139.054 83.6951C140.025 82.7229 140.025 81.0562 139.054 80.084C138.084 79.1117 136.42 79.1117 135.449 80.084L132.122 83.4174L128.794 80.084C127.823 79.1117 126.16 79.1117 125.189 80.084C124.219 81.0562 124.219 82.7229 125.189 83.6951L128.517 87.0285L125.189 90.3619C124.219 91.3342 124.219 93.0008 125.189 93.9731C125.744 94.5287 126.298 94.6676 126.992 94.6676C127.685 94.6676 128.239 94.3899 128.794 93.9731L132.122 90.6397L135.449 93.9731C136.004 94.5287 136.558 94.6676 137.252 94.6676C137.945 94.6676 138.5 94.3899 139.054 93.9731C140.025 93.0008 140.025 91.3342 139.054 90.3619L135.727 87.0285Z",
    fill: "#B8C5CC"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M195.75 47.5736V55.0652H37.7501V47.5736C37.7501 44.6007 40.1243 42.3413 42.9733 42.3413H190.526C193.494 42.3413 195.75 44.7196 195.75 47.5736Z",
    fill: "#384252"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7542 50.903C45.7376 50.903 46.5348 50.1043 46.5348 49.1192C46.5348 48.1342 45.7376 47.3355 44.7542 47.3355C43.7708 47.3355 42.9736 48.1342 42.9736 49.1192C42.9736 50.1043 43.7708 50.903 44.7542 50.903Z",
    fill: "#F7F9F9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.333 50.903C51.3163 50.903 52.1135 50.1043 52.1135 49.1192C52.1135 48.1342 51.3163 47.3355 50.333 47.3355C49.3495 47.3355 48.5522 48.1342 48.5522 49.1192C48.5522 50.1043 49.3495 50.903 50.333 50.903Z",
    fill: "#F7F9F9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.031 50.903C57.0145 50.903 57.8116 50.1043 57.8116 49.1192C57.8116 48.1342 57.0145 47.3355 56.031 47.3355C55.0476 47.3355 54.2505 48.1342 54.2505 49.1192C54.2505 50.1043 55.0476 50.903 56.031 50.903Z",
    fill: "#F7F9F9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M189.34 29.7362C188.153 29.7362 187.202 28.785 187.202 27.5958V3.69398C187.202 2.50485 188.153 1.55353 189.34 1.55353C190.526 1.55353 191.477 2.50485 191.477 3.69398V27.5958C191.477 28.785 190.526 29.7362 189.34 29.7362Z",
    fill: "#828A99"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M206.672 48.049C206.672 46.8599 207.621 45.9084 208.807 45.9084H232.668C233.855 45.9084 234.805 46.8599 234.805 48.049C234.805 49.238 233.855 50.1895 232.668 50.1895H208.807C207.621 50.1895 206.672 49.238 206.672 48.049Z",
    fill: "#828A99"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M204.772 32.5902C203.94 31.7578 203.94 30.3309 204.772 29.4985L221.748 12.6126C222.578 11.7802 224.002 11.7802 224.834 12.6126C225.664 13.445 225.664 14.872 224.834 15.7044L207.977 32.5902C207.026 33.4226 205.602 33.4226 204.772 32.5902Z",
    fill: "#828A99"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M140.28 70.6919L148.122 42.9839L180.331 46.7005L169.085 64.7575L177.796 71.7288L159.043 112.818L160.088 81.0069L140.28 70.6919Z",
    fill: "#384252"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19_110",
    x: 15.958,
    y: 31.9838,
    width: 202,
    height: 151.741,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19_110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19_110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19_110",
    x1: 117.939,
    y1: -22.7514,
    x2: 116.223,
    y2: 66.2457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#253240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253040",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19_110",
    x1: 116.906,
    y1: 40.4917,
    x2: 116.906,
    y2: 151.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D6674"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#4E5662"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileWarning);
export default __webpack_public_path__ + "static/media/mobileWarning.53769631535aa17ec3ae397561e9c0cb.svg";
export { ForwardRef as ReactComponent };